import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const CrossCircleFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 0.500122C2.375 0.500122 0.5 4.25012 0.5 8.00012C0.5 11.7501 2.375 15.5001 8 15.5001C13.625 15.5001 15.5 11.7501 15.5 8.00012C15.5 4.25012 13.625 0.500122 8 0.500122ZM5.82696 11.1592L7.99799 8.98819L10.169 11.1592L11.159 10.1693L8.98794 7.99824L11.159 5.82721L10.169 4.83727L7.99799 7.00829L5.82697 4.83727L4.83702 5.82721L7.00804 7.99824L4.83701 10.1693L5.82696 11.1592Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const CrossCircleFilledSize16 = hoc(forwardRef(CrossCircleFilledSize16Component), 'CrossCircleFilledSize16');

export { CrossCircleFilledSize16 as default };
//# sourceMappingURL=CrossCircleFilledSize16.js.map
